export default __webpack_public_path__ + "static/media/hyperlink-link-icon.a0935436.svg";